import { render, staticRenderFns } from "./TemplateRichTextField.vue?vue&type=template&id=9f5448c8&scoped=true"
import script from "./TemplateRichTextField.vue?vue&type=script&lang=ts"
export * from "./TemplateRichTextField.vue?vue&type=script&lang=ts"
import style0 from "./TemplateRichTextField.vue?vue&type=style&index=0&id=9f5448c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5448c8",
  null
  
)

export default component.exports